module.exports = require("@trademe/ng-defer-load/dist/defer-load.directive");